import { useI18n } from "@/utils/i18n";
import styles from "./not-found-view.module.css";

export default function NotFoundView() {
  const { t } = useI18n();

  return (
    <div className={styles.empty}>
      <div>
        <h1>{t("notFound.title")}</h1>
        <p>{t("notFound.description")}</p>
      </div>
    </div>
  );
}
